import { useLoggedInUser } from 'src/services/api/auth/use-logged-in-user';
import { usePollConversations } from 'src/services/api/messages/use-poll-conversations';
import { useIsLive } from 'src/services/websocket/use-is-live';
import { useLiveRefetch } from 'src/services/websocket/use-live-refetch';
import { useWebSocket } from 'src/services/websocket/use-websocket';

export default function LiveUpdatesHost() {
    useWebSocket();
    const isLive = useIsLive();
    const { data: loggedInUser } = useLoggedInUser();
    const conversations = usePollConversations(loggedInUser, isLive);

    useLiveRefetch({
        isLive,
        enabled: conversations.enabled,
        refetch: conversations.refetch,
        shouldRefetchFrame: (frame) => frame.type === 'message.created',
    });

    return null;
}
